export default __webpack_public_path__ + "static/media/pixelator-webpage.dcd041ee.png";